import React from 'react'
import TopRightLink from '../../../components/atoms/formFields/buttons/topRightLink'
import CardWrapper from '../../../components/molecules/CardWrapper'
import CardHeader from '../../../components/atoms/cardHeader'
import ProductForm from './ProductForm'

const RequestNewProduct = () => {

  return (
    <div className="content d-flex flex-column flex-column-fluid">
      <div className="container">
        <div className="align-items-center d-flex justify-content-end pb-6">
          <TopRightLink name={"Add Product To Inventory"} url="/addProductToInventory"/>
        </div>
      </div>

      <CardWrapper>
        <CardHeader name={"Request a New Product"} tooltipText={"Fill the product details and images to request adding a new product."}/>

        <div className="card-body p-4 px-10">
          <ProductForm />
        </div>
      </CardWrapper>
    </div>
  )
}

export default RequestNewProduct
